import React from "react";

const MilesRevolutionDesktop = () => {
  return (
    <>
      {/* Desktop Version */}
      <div className="w-full justify-center py-12 bg-[#F4F4F4] md:block hidden">
        <div className=" flex flex-col items-center ">
          <h2 className="text-[36px] font-semibold text-[#1D1D1D] mb-6 text-center leading-[115%] tracking-[-1.44px] ">
            <span className="border-[#ca7216] border-b-[4px] mt-3">
              Miles is More Than Education; It’s a Revolution
            </span>
          </h2>

          <div className="lg:container flex flex-col md:flex-row w-full justify-center items-start mt-6 mx-auto">
            <div className="grid grid-cols-2 gap-6 md:gap-8 mb-6 md:mb-0">
              <div className="bg-[#FFF] p-6 rounded-[16px] text-center shadow-md w-[178px] h-[134px]">
                <h3 className="text-[40px] font-bold text-[#3174d6]">70k +</h3>
                <p className="text-[#5C5C5C] text-[24px] font-medium">Alumni</p>
              </div>
              <div className="bg-[#FFF] p-6 rounded-[16px] text-center shadow-md w-[178px] h-[134px]">
                <h3 className="text-[40px] font-bold text-[#008D82]">700 +</h3>
                <p className="text-[#5C5C5C] text-[24px] font-medium">
                  Professionals
                </p>
              </div>
              <div className="bg-[#FFF] p-6 rounded-[16px] text-center shadow-md w-[178px] h-[134px]">
                <h3 className="text-[40px] font-bold text-[#FFBA08]">600 +</h3>
                <p className="text-[#5C5C5C] text-[24px] font-medium">
                  Corporates
                </p>
              </div>
              <div className="bg-[#FFF] p-6 rounded-[16px] text-center shadow-md w-[178px] h-[134px]">
                <h3 className="text-[40px] font-bold text-[#BD132D]">100 +</h3>
                <p className="text-[#5C5C5C] text-[24px] font-medium">
                  Universities
                </p>
              </div>
            </div>

            <div className=" gap-5 ml-[6%] mt-5">
              <h3 className="text-[32px] font-semibold text-[#1D1D1D] mb-2 leading-[116%]">
                Bootstrapped and Ballistic
              </h3>
              <hr className="w-12  mb-1" />
              <p className="text-[#5C5C5C] font-[Work Sans] text-[18px] font-normal leading-[24px] tracking-[-0.72px]">
                We’re a self-made success story, focusing steadfastly
                <br /> on fundamentals and outcomes rather than external
                <br /> fundraising. Growing at an astonishing CAGR of 70%+
                <br /> and distinguished as one of the few profitable Ed-
                <br /> Tech companies in India, we are poised for substantial
                <br /> growth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MilesRevolutionDesktop;
